<template>
  <div class="editorBlogProductsSection" v-if="items && items.length">
    <LazyHydrate when-visible>
      <flexible-slider-section
        disable-native-link
        :section="{ title: data.title, data: { products: items } }"
      />
    </LazyHydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import FlexibleSliderSection from '~/components/Flexible/FlexibleSliderSection';

export default {
  name: 'EditorBlogProductsSection',
  components: { FlexibleSliderSection, LazyHydrate },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.editorBlogProductsSection {
  max-width: 108rem;
  margin: 0 auto 2rem;
  padding-bottom: 2rem;

  @include rwd('tablet') {
    padding-top: 0.1rem;
    padding-bottom: 6rem;
    margin-bottom: 4rem;
    margin-top: 6rem;
  }

  ::v-deep {
    .sliderTiles__slider .sliderTiles__slide {
      @include rwd('small-tablet', true) {
        width: 50% !important;
      }

      @include rwd('large-tablet', true) {
        width: 33.333% !important;
      }
    }
  }
}
</style>
